export default __webpack_public_path__ + "static/Fly8-56c687ef914d9b70010b732526bbd1b4.mp3";